import React, { FC, useEffect } from 'react';
import { InteractionType } from '@azure/msal-browser';
import { AuthError } from '../components/AuthError/AuthError';
import Loader from '../components/Loader/Loader';
import MainLayout from '../layout/MainLayout/MainLayout';
import { Outlet } from 'react-router-dom';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import { useAuthorization } from '../context/AuthorizationContext';
import { setAuthorizationSetter } from '../api/api';
import NotAuthorized from '../pages/NotAuthorized/NotAuthorized';

const ProtectedMainLayout: FC = () => {
    const { isAuthorized, setIsAuthorized } = useAuthorization();

    useEffect(() => {
        setAuthorizationSetter(setIsAuthorized);
        return () => setAuthorizationSetter(() => {/* no-op */});
    }, [setIsAuthorized]);

    const authRequest = {
        ...loginRequest,
    };

    const content = () => {
        return isAuthorized ? <Outlet /> : <NotAuthorized />;
    };

    return (
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={authRequest}
            errorComponent={AuthError}
            loadingComponent={Loader}
        >
            <MainLayout>{content()}</MainLayout>
        </MsalAuthenticationTemplate>
    );
};

export default ProtectedMainLayout;
